import type { ExternalFeatureFlagContextType } from "contexts/ExternalFeatureFlag"
import { type FeatureFlagData } from "hooks/useDynamicYieldExperience/types"

export interface UseExternalFeatureFlagParams {
  serverSideDynamicYieldProps?: FeatureFlagData[]
}

export interface ExternalFeatureFlag {
  campaign: string
  flag: string
  decisionId: string
}

const useExternalFeatureFlag = (): ExternalFeatureFlagContextType => ({
  flags: null,
  isFeatureFlagLoading: false,
  getCampaign: () => null
})

export default useExternalFeatureFlag
